import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';
import { LeftOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import {Button, Form} from 'antd';
import _, {toNumber} from 'lodash';
import {observer} from 'mobx-react-lite';

import {Header} from '../../../components/Header/Header';
import Layout from '../../../components/Layout/Layout';
import dependsBase from '../../../config/depends.json'
import labels from '../../../config/labels.json';
import {ILabel} from '../../../config/lebels-type';
import {INDEX} from '../../../config/routes';
import unitsBase from '../../../config/units.json'
import {Store} from '../../../model/store/Store';
import {createIndicator, createIndicatorVariables} from '../../../shared/graphql/__generated__/createIndicator';
import {MUTATION_CREATE_INDICATOR} from '../../../shared/graphql/indicator';

import {InputWithValue} from './InputWithValue';



export const MultiForm = observer(() => {

    const [loading, setLoading] = useState(false);
    const [create] = useMutation<createIndicator, createIndicatorVariables>(MUTATION_CREATE_INDICATOR);
    const {auth} = useInstance(Store)
    const navigate = useNavigate()
    const {state} = useLocation();
    const {t} = useTranslation()

    // загружаем зависимости от идентификатора
    const depends = _.filter(dependsBase, item => item.identifier === state?.identifier)[0].depends
    const labelGroup = _.filter(labels, (label: ILabel) => label.identifier === state?.identifier)[0]?.label


    const onFinish = async (data:any) => {

        setLoading(true);

        for (const [key, value] of Object.entries(data)) {
            await create({
                variables: {
                    data: {
                        identifier: key,
                        value: toNumber(value),
                    }
                },
            })
        }

        auth.needUpdate()
        setLoading(false);
        navigate(INDEX)

    }

    return (
        <Layout header={<Header title={t(labelGroup)} left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'} icon={<LeftOutlined/>}/>}/>} >
            <Form layout={'vertical'} onFinish={onFinish} validateTrigger={'onFinish'} disabled={loading}>
                {
                    _.map(depends, item => {

                        const unit = _.filter(unitsBase, unitBase => unitBase.identifier === item)[0]
                        const labelInput = _.filter(labels, (label: ILabel) => label.identifier === item)[0]?.label

                        let input = undefined
                        if (unit.unit === 'cm' || unit.unit === 'kg') {
                            input = <InputWithValue indicator={item} style={{width: '100%'}} addonAfter={t(unit.unit)}/>
                        }

                        return (
                        <Form.Item name={item} label={t(labelInput)} key={item} rules={[
                            {required: true, message: t('Please, fill data')!},
                        ]}>
                            {input}
                        </Form.Item>
                    )})
                }
                <Form.Item>
                    <Button loading={loading} htmlType={'submit'} type={'primary'} block>Далее</Button>
                </Form.Item>
            </Form>
        </Layout>

    )
})